/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { JobSpecTemplateFinderDialogComponent } from './job-spec-template-finder-dialog.component';

export const jobSpecTemplateFinderDialogRoute = createDialogRoute({
  component: JobSpecTemplateFinderDialogComponent,
});
